import { LocalizedParagraph } from '@mews-commander/ui';
import { FloatingPanel } from '@mews/b2b-ui';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button, Stack } from '@optimus-web/core';
import { Configure2FADeviceRecoveryPins } from '../../Configure2FA/Configure2FADevice/Configure2FADeviceRecoveryPins';

interface Configure2FAPanelRecoveryPinsProps {
    recoveryPins: string[];
    onClose: () => void;
}

export function Configure2FAPanelRecoveryPins({ onClose, recoveryPins }: Configure2FAPanelRecoveryPinsProps) {
    return (
        <FloatingPanel
            modal
            size="small"
            active
            onClose={onClose}
            title={<LocalizedText textKey={TextKey.RecoveryCodes} />}
            footer={{
                primary: (
                    <Button size="medium" variant="primary" onClick={onClose} type="submit">
                        <LocalizedText textKey={TextKey.Done} />
                    </Button>
                ),
            }}
        >
            <Stack vertical spacing="300">
                <LocalizedParagraph textKey={TextKey.RecoveryCodesIntro} />
                <Configure2FADeviceRecoveryPins recoveryPins={recoveryPins} />
            </Stack>
        </FloatingPanel>
    );
}
